// Paired hover for the Day timeline. The spine segment and the bubble for a
// given time entry share a `data-te-id`. When either is hovered, both get a
// `.is-peer-hover` class so a CSS rule can highlight them as a unit.
//
// `mouseenter`/`mouseleave` don't bubble, so they can't be delegated on
// document directly. We delegate `mouseover`/`mouseout` (which do bubble)
// and use the `relatedTarget` containment check to fire only on a true
// enter/leave of the matched element — not on moves between its children.

const PEER_CLASS = "is-peer-hover"
const PEER_SELECTOR = ".te-segment, .te-bubble"

function setPeerHover(teId: string | null, on: boolean): void {
  if (!teId) return
  document
    .querySelectorAll<HTMLElement>(`[data-te-id="${teId}"]`)
    .forEach(el => el.classList.toggle(PEER_CLASS, on))
}

function peerOf(node: EventTarget | null): HTMLElement | null {
  const el = node as HTMLElement | null
  return el?.closest?.<HTMLElement>(PEER_SELECTOR) ?? null
}

document.addEventListener("mouseover", (e) => {
  const peer = peerOf(e.target)
  // Skip if the pointer came from within the same peer (child-to-child move).
  if (!peer || peer.contains(e.relatedTarget as Node)) return
  setPeerHover(peer.getAttribute("data-te-id"), true)
})

document.addEventListener("mouseout", (e) => {
  const peer = peerOf(e.target)
  // Skip if the pointer is still inside the same peer.
  if (!peer || peer.contains(e.relatedTarget as Node)) return
  setPeerHover(peer.getAttribute("data-te-id"), false)
})
